export default "__VITE_ASSET__B2oJjzJ2__"